import api from '../token';

export const AddFamilia = async (dados) => {
  try {
    const response = await api.post('/addFamilia', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
